import React, { Component } from "react";
import {Modal } from 'semantic-ui-react'
import './cookies.css'

import Cookies_content from './cookie_content';

class Cookies extends Component {
  constructor (props) {
    super(props);
    this.state = {
      openModal: false,
    }
  }

  componentDidMount(){
    // console.log(window.innerWidth)
  }

  consent(){
    this.setState({openModal: false});
    localStorage.setItem("consent", "true");
    localStorage.setItem("cookie1", "true");
    localStorage.setItem("cookie2", "true");
    localStorage.setItem("cookie3", "true");
    document.getElementById("cookie-consent").style.display = "none";
    document.getElementById("btncookies").style.display = "block";
  }

  unconsent(){
    this.setState({openModal: false});
    localStorage.removeItem("consent");
    localStorage.setItem("cookie1", "false");
    localStorage.setItem("cookie2", "false");
    localStorage.setItem("cookie3", "false");
    document.getElementById("cookie-consent").style.display = "block";
    document.getElementById("btncookies").style.display = "none";
    document.getElementById("cookie-consent").style.zIndex =2147483647;
  }

  cancle(){
    document.getElementById("cookie-consent").style.display = "none";
    document.getElementById("btncookies").style.display = "block";
    // document.getElementById("cookie-consent").style.zIndex =2147483647;
  }

  settings(){
    this.setState({openModal: true});
    document.getElementById("cookie-consent").style.zIndex = 900;
  }

  render() {
    return (
      <div>
        <Modal
          onClose={() => this.setState({openModal: false}) }
          onOpen={() => this.setState({openModal: true}) }
          open={this.state.openModal}
          size="tiny"
          style={{position: "relative", zIndex: 1510}}
        >

          <Modal.Header className="text-center"><img src="images/logo_1.png" style={{height: 50, width: 'auto'}} /></Modal.Header>
          <Modal.Content scrolling={true} >
            <Modal.Description style={{marginLeft: 10, marginRight: 10}}>
                <h3>ศูนย์การตั้งค่าความเป็นส่วนตัว</h3>
                <br />
                <p>เมื่อคุณเข้าชมเว็บไซต์ใดก็ตาม ไซต์นั้นอาจจัดเก็บหรือดึงข้อมูลจากเบราว์เซอร์ของคุณ ส่วนใหญ่แล้วอยู่ในรูปแบบของคุกกี้ ข้อมูลนี้อาจเกี่ยวกับคุณ การตั้งค่าของคุณ อุปกรณ์ของคุณ หรือเพื่อช่วยให้ไซต์ทำงานอย่างที่คุณต้องการ ซึ่งมักเป็นข้อมูลที่ไม่สามารถระบุตัวตนของคุณได้โดยตรง แต่ช่วยให้คุณใช้งานเว็บตามความต้องการส่วนบุคคลได้มากยิ่งขึ้น คุณสามารถปฏิเสธไม่ให้คุกกี้บางประเภททำงานได้ คลิกที่หัวข้อประเภทอื่นๆ เพื่อดูข้อมูลเพิ่มเติมและเปลี่ยนการตั้งค่าเริ่มต้นของเรา อย่างไรก็ตาม คุณควรทราบว่าการบล็อกคุกกี้บางประเภทอาจส่งผลต่อการใช้งานไซต์และบริการที่เรามีให้ใช้งาน</p>
                <h3>จัดการการกำหนดลักษณะความยินยอม</h3>

                <Cookies_content />
              </Modal.Description>
          </Modal.Content>
          <Modal.Actions >
            <button className="btn btn-secondary" 
                    style={{fontFamily: 'Kanit-Light'}}
                    onClick={() => {
                      this.unconsent()
                    }}
            >ยกเลิกคุกกี้</button>
            <button className="button utf-search-btn-item" style={{fontFamily: 'Kanit-Light'}} onClick={() => {this.consent()}}>ยอมรับทั้งหมด</button>
          </Modal.Actions>
        </Modal>     

      <div
        id="btncookies"
        className="show-div"
        style={{
          textAlign: "left",
          position: "fixed",
          left: 10,
          bottom: 10,
          height: "40px",
          zIndex: 2147483647,
          display: localStorage.getItem("consent") ? "block" : "none"
        }}
      >
        <a
          href="#"
          className="cookies-text"
          onClick={() => {
            // this.setState({openModal: true});
            this.settings()
          }}
        >
          <p><font color="#fff">การตั้งค่าคุกกี้</font></p>
        </a>
        <img
          id="imgcookie"
          style={{
            height: "40px",
            position: "fixed",
            left: 10,
            bottom: 10,
            height: "40px"
          }}
          src="https://core.becookies.tech/static/cookie-toast.png"
        />
      </div>

      <div
        id="cookie-consent"
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          height: "auto",
          minHeight: 21,
          zIndex: 2147483647,
          background: "rgb(100, 88, 98, 0.7)",
          color: "rgb(255, 255, 255)",
          padding: "8px 18px",
          fontFamily: "Kanit-Light",
          fontSize: 14,
          textAlign: "left",
          bottom: 0,
          // opacity: 1,
          marginLeft: window.innerWidth < 1000? 0: 250,
          marginRight: window.innerWidth < 1000? 0: 250,
          marginBottom: window.innerWidth < 1000? 0: 20,
          borderRadius: window.innerWidth < 1000? 0: 10,
          display: localStorage.getItem("consent") ? "none" : "block"
        }}
      >
        <span style={{ height: 30 }}>
          คลิกไทยโฮม โดยศูนย์ข้อมูลอสังหาริมทรัพย์ ธนาคารอาคารสงเคราะห์
          ใช้คุกกี้เพื่อเพิ่มประสิทธิภาพในการให้บริการ
          และส่งมอบประสบการณ์ที่ดีในการใช้งานเว็บไซต์แก่ท่าน หากท่านดำเนินการต่อ
          หรือปิดข้อความนี้ลง เราถือว่าท่านยอมรับการใช้งานคุกกี้ และ{" "}
          <a
            href="/privacy-policy"
            style={{
              textDecoration: "none",
              color: "rgb(241, 214, 0)"
            }}
          >
            นโยบายความเป็นส่วนตัว
          </a>
        </span>
        <br />


        <button
          className="button utf-search-btn-item"
          style={{
            float: "right",
            display: "block",
            padding: "5px 8px",
            minWidth: 100,
            marginLeft: 5,
            borderRadius: 5,
            cursor: "pointer",
            fontFamily: "Kanit-Light",
            textAlign: "center"
          }}
          onClick={() => {
            this.consent()
          }}
        >
          ยอมรับทั้งหมด
        </button>

        <button className="button utf-search-btn-item" 
                    style={{float: "right",
                            display: "block",
                            padding: "5px 8px",
                            minWidth: 100,
                            height: '100%',
                            marginLeft: 5,
                            borderRadius: 5,
                            cursor: "pointer",
                            fontFamily: "Kanit-Light",
                            textAlign: "center",
                            backgroundColor: '#645c5c'}}
                    onClick={() => {
                      this.cancle()
                    }}
            >ยกเลิก</button>

            <button className="button utf-search-btn-item" 
                    style={{float: "right",
                            display: "block",
                            padding: "5px 8px",
                            width: 32,
                            height: 33,
                            marginLeft: 5,
                            borderRadius: 50,
                            cursor: "pointer",
                            fontFamily: "Kanit-Light",
                            textAlign: "center",
                            backgroundColor: '#645c5c'}}
                    onClick={() => {
                      this.settings()
                    }}
            ><i className="sl sl-icon-settings"></i></button>
        
      </div>
    </div>
    );
  }
}

export default Cookies;
